import React, {useState} from "react";
import {BarChart3, ListChecks, Save, Settings2, TicketPercent} from "lucide-react";
import usePermissions from "../../hooks/usePermissions";
import {HeaderAction, PageHeader} from "../../stock/StockUI";
import ReturnsListTab from "./ReturnsListTab";
import CreditNotesTab from "./CreditNotesTab";
import ReturnsReportTab from "./ReturnsReportTab";
import ReturnsSettingsTab, {RULES_FORM_ID} from "./ReturnsSettingsTab";

const TABS = [
    {key: "returns", label: "Retours & échanges", Icon: ListChecks},
    {key: "credit-notes", label: "Avoirs", Icon: TicketPercent},
    {key: "report", label: "Rapports", Icon: BarChart3},
    {key: "settings", label: "Réglages", Icon: Settings2},
];

// Retours & échanges (retail): returns done on the POS, avoirs, report and
// rules — clicoo ReturnController / CreditNoteController.
const ReturnsPage = () => {
    const {canUpdate} = usePermissions();
    const canManage = canUpdate("returns");
    const [activeTab, setActiveTab] = useState("returns");

    return (
        <div className="min-h-screen bg-white dark:bg-gray-900">
            <PageHeader
                title="Retours & échanges"
                tabs={TABS}
                activeTab={activeTab}
                onTabChange={setActiveTab}
                actions={activeTab === "settings" && canManage && (
                    <HeaderAction icon={Save} label="Enregistrer"
                                  onClick={() => document.getElementById(RULES_FORM_ID)?.requestSubmit()}/>
                )}
            />

            {/* Lists are edge-to-edge like the catalogue; the settings form is centred */}
            {activeTab === "returns" && <ReturnsListTab/>}
            {activeTab === "credit-notes" && <CreditNotesTab canManage={canManage}/>}
            {activeTab === "report" && <ReturnsReportTab/>}
            {activeTab === "settings" && <ReturnsSettingsTab canManage={canManage}/>}
        </div>
    );
};

export default ReturnsPage;
